import React, { useState, Suspense } from 'react';
import { Text, Spinner, SpinnerSize } from '@bechtel/gds';
import {
  TabButtonStyled,
  ProjectAdminContainerStyled,
  ProjectAdminHeaderStyled,
  ProjectAdminTabStyled,
} from '../styled';
import { QtyReportingTabList } from './tab-data';
import { QtyReportingTab, QtyReportingTabType } from './types';
import { map } from 'lodash';
import { ErrorBoundary } from '@bechtel/client-common';
import { General } from './general';
import { PlanningTargetCalc } from './planning-target-calc';
import { WeldProgramMgmt } from './weld-program-mgmt';
import { InspectionTestRecord } from './inspection-test-record';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';

export const QuantityReporting = () => {
  const [selectedTab, setSelectedTab] = useState<QtyReportingTabType>(QtyReportingTabType.GENERAL);
  const { i18n } = useLingui();
  return (
    <ProjectAdminContainerStyled>
      <ProjectAdminHeaderStyled>
        <Text family="graphik" size="600" weight="600" color="white">
          <Trans>Quantity Reporting</Trans>
        </Text>
      </ProjectAdminHeaderStyled>
      <ProjectAdminTabStyled>
        {map(QtyReportingTabList, (tabItem: QtyReportingTab) => {
          return (
            <TabButtonStyled
              selected={tabItem.value === selectedTab}
              onClick={() => {
                setSelectedTab(tabItem.value);
              }}
              key={tabItem.value}
            >
              {i18n._(tabItem.label)}
            </TabButtonStyled>
          );
        })}
      </ProjectAdminTabStyled>
      {selectedTab == QtyReportingTabType.GENERAL && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <General />
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == QtyReportingTabType.PLANNING_TARGET_CALC && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <PlanningTargetCalc />
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == QtyReportingTabType.WELD_PROGRAM_MGMT && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <WeldProgramMgmt />
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == QtyReportingTabType.INSPECTION_TEST_RECORD && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <InspectionTestRecord />
          </Suspense>
        </ErrorBoundary>
      )}
    </ProjectAdminContainerStyled>
  );
};
